<template>
  <div class="place-content"> 
    
  </div>
</template>
  
  <script>
  export default {
    props: {
      id: {
        type: Number,
        required: true
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
    .place-content{
      padding: 0 20px;
      margin-top:10px;
     .history{
      border-radius: 4px;
      margin-bottom: 20px;
      .history-title{
        font-size: 18px;
        font-weight: 600;
        padding: 10px 10px;
      }
      .history-content{
        font-size: 14px;
        font-weight: 400;
        padding: 10px 10px;
      }     
    }
    .image-content{
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: space-around;
      border-radius: 10px;
      flex-wrap: wrap;  
      .img{
        width: 48%;
        height: 100%;
        border-radius: 10px;
      }
    }
  }
  </style>